export const CREATE_UBER_VOUCHER = 'Uber/CREATE_UBER_VOUCHER';
export const CREATE_UBER_VOUCHER_SUCCESS = 'Uber/CREATE_UBER_VOUCHER_SUCCESS';
export const CREATE_UBER_VOUCHER_FAILED = 'Uber/CREATE_UBER_VOUCHER_FAILED';

export const ENTERPRISE_SEARCH_LOCATIONS = 'Enterprise/ENTERPRISE_SEARCH_LOCATIONS';
export const ENTERPRISE_SEARCH_LOCATIONS_SUCCESS = 'Enterprise/ENTERPRISE_SEARCH_LOCATIONS_SUCCESS';
export const ENTERPRISE_SEARCH_LOCATIONS_FAILED = 'Enterprise/ENTERPRISE_SEARCH_LOCATIONS_FAILED';

export const CREATE_RENTAL = 'Enterprise/CREATE_RENTAL';
export const CREATE_RENTAL_SUCCESS = 'Enterprise/CREATE_RENTAL_SUCCESS';
export const CREATE_RENTAL_FAILED = 'Enterprise/CREATE_RENTAL_FAILED';

export const AUDATARGET_SEARCH_VENDOR = 'Audatarget/AUDATARGET_SEARCH_VENDOR';
export const AUDATARGET_SEARCH_VENDOR_SUCCESS = 'Audatarget/AUDATARGET_SEARCH_VENDOR_SUCCESS';
export const AUDATARGET_SEARCH_VENDOR_FAILED = 'Audatarget/AUDATARGET_SEARCH_VENDOR_FAILED';

export const AUDATARGET_GET_AVAILABILITY = 'Audatarget/AUDATARGET_GET_AVAILABILITY';
export const AUDATARGET_GET_AVAILABILITY_SUCCESS = 'Audatarget/AUDATARGET_GET_AVAILABILITY_SUCCESS';
export const AUDATARGET_GET_AVAILABILITY_FAILED = 'Audatarget/AUDATARGET_GET_AVAILABILITY_FAILED';

export const AUDATARGET_BOOK_APPOINTMENT = 'Audatarget/AUDATARGET_BOOK_APPOINTMENT';
export const AUDATARGET_BOOK_APPOINTMENT_SUCCESS = 'Audatarget/AUDATARGET_BOOK_APPOINTMENT_SUCCESS';
export const AUDATARGET_BOOK_APPOINTMENT_FAILED = 'Audatarget/AUDATARGET_BOOK_APPOINTMENT_FAILED';

export const CLEAR_ERRORS = 'Services/CLEAR_ERRORS';
export const CLEAR_STATE = 'Services/CLEAR_STATE';
